import React, { Component } from 'react';
import { compose } from 'recompose';
import withAuthorization from '../Session/withAuthorization';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { db, storage } from '../../firebase';
import { Modal } from '../Modal/modal';
import './polls.css';
import searchIcon from '../../assets/icons8-search@2x.png'

class Polls extends Component {
    constructor() {
        super();
        this.state = {
            leads: [],
            searchList: [],
            deleteModal: false,
            lead: null,
            firebaseLeads: null
        }
        this.filterList = this.filterList.bind(this);
        this.deleteInterviewee = this.deleteInterviewee.bind(this);
        this.displayRaport = this.displayRaport.bind(this)
    }

    componentDidMount() {
        this.getLeads();
    }

    getLeads() {
        db.getLeads().on('value', snap => {
            console.log(snap)
            const leads = snap.val();
            var leadsFromIpads = [];
            if (leads !== null) {
                Object.keys(leads).forEach(ipadKey => {
                    this.setState({ firebaseLeads: leads })
                    var ipads = [];
                    ipads.push(leads[ipadKey])
                    ipads.map((lead) => {
                        Object.keys(lead).forEach(key => {
                            leadsFromIpads.push(lead[key])
                        })
                        return leadsFromIpads
                    })
                });
            }
            this.setState({ leads: leadsFromIpads, searchList: leadsFromIpads })
        })
    }

    filterList(e) {
        var updatedList = this.state.leads;
        updatedList = updatedList.filter((item) => {
            var name = item.name_first + ' ' + item.name_last
            return name.toLowerCase().search(e.target.value.toLowerCase()) !== -1;
        })

        this.setState({ searchList: updatedList })
    }

    deleteInterviewee(leadToDelete) {
        const { firebaseLeads } = this.state;
        var deviceUUID = null;
        var leadKey = null;
        var pdfName = null;
        Object.keys(firebaseLeads).forEach(ipadKey => {
            var ipads = [];
            ipads.push(firebaseLeads[ipadKey])
            ipads.map((lead) => {
                Object.keys(lead).forEach(key => {
                    if (leadToDelete.timestamp === lead[key].timestamp) {
                        deviceUUID = ipadKey
                        leadKey = key
                        pdfName = lead[key].name_first + '-' + lead[key].name_last + '-' + lead[key].timestamp
                    }
                });
                return ipadKey
            });
        });
        db.deleteLead(deviceUUID, leadKey)
            .then(() => storage.deleteRaport(pdfName))
            .then(() => {
                this.setState({ deleteModal: false });
            })
    }

    displayRaport(lead) {
        const id = lead.name_first + "-" + lead.name_last + "-" + lead.timestamp
        storage.getRaport(id).then(url => {
            console.log(url)
            window.open(url)
        })
    }

    render() {
        const { leads, deleteModal, lead } = this.state;
        return (
            <div className={`polls-container`}>
                {lead ?
                    <Modal title={'Czy chcesz na pewno usunąć rekord?'}
                        subtitle={'"' + lead.name_first + ' ' + lead.name_last + '"' + ' zostanie usunięty i nie będzie dostępu do tych danych.'}
                        modalState={deleteModal}
                        actionButton1={() => this.deleteInterviewee(lead)}
                        actionButtonName1={'Usuń'}
                        actionButton2={() => this.setState({ deleteModal: false })}
                        actionButtonName2={'Anuluj'}
                    /> : null}
                <label className={`polls-title`}>Klienci</label>
                <label className='search-container'>
                    <img className="search-icon" alt='' src={searchIcon} height={18} width={18} />
                    <input required type="text" className='search-textfield' onChange={this.filterList} />
                </label>
                {leads.length === 0 ? null :
                    <ListGroup className="clients-container">
                        {this.state.searchList.map((lead) => {
                            return (
                                <ListGroupItem key={lead.timestamp}>
                                    <label>{lead.name_first} {lead.name_last}</label>
                                    <button className={'remove-polls-button'} onClick={() => this.setState({ deleteModal: true, lead: lead })}>Usuń</button>
                                    <button className={'remove-polls-button'} onClick={() => this.displayRaport(lead)}>Raport</button>
                                </ListGroupItem>
                            )
                        })}
                    </ListGroup>
                }
            </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

export default compose(
    withAuthorization(authCondition)
)(Polls);